import { Gradients } from '@/shared/components/theme/gradient';

const BudgetStatusBreakpoints = {
  critical: 90,
  warning: 69,
  good: 0,
};

export const useBudgetStatus = (currValue: number, maxValue: number) => {
  const percentage = Math.round((currValue / maxValue) * 100);

  const svgGradient =
    percentage > BudgetStatusBreakpoints.critical
      ? 'url(#redSvgGradient)'
      : percentage > BudgetStatusBreakpoints.warning
        ? 'url(#orangeYellowDotGradient)'
        : 'url(#turquoiseBlueGreenGradient)';

  const gradient =
    percentage > BudgetStatusBreakpoints.critical
      ? Gradients.pinkRedGradient
      : percentage > BudgetStatusBreakpoints.warning
        ? Gradients.orangeYellowGradient
        : Gradients.turquoiseBlueGreenGradient;

  return {
    svgGradient,
    gradient,
    percentage,
  };
};
